(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-data/assets/javascripts/helpers/generate-local-id.js') >= 0) return;  svs.modules.push('/components/chat/chat-data/assets/javascripts/helpers/generate-local-id.js');

'use strict';

let nextId = 0;
setGlobal('svs.components.chat.chatData.helpers.generateLocalId', () => ++nextId);

 })(window);